import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./GoToTopButton.scss";

const GoToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const handleScroll = () => {
        if (window.scrollY > 100) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div className={`go-to-top-button ${isVisible ? "visible" : ""}`}>
            <button onClick={scrollToTop}>
                <FaArrowUp className="icon" />
            </button>
        </div>
    );
};

export default GoToTopButton;
